import { render, staticRenderFns } from "./DocumentVerificationRejectScreen.vue?vue&type=template&id=a7d16160&"
import script from "./DocumentVerificationRejectScreen.vue?vue&type=script&lang=js&"
export * from "./DocumentVerificationRejectScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports